import React from "react"
import {buildClassList} from "../helpers/utilities"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import {faBook, faHandsHelping} from "@fortawesome/free-solid-svg-icons"

const iconList = {
  "Book": <FontAwesomeIcon className="header-icon icon-book hidden lg:inline-block" icon={faBook} height="1em" width="1em" />,
  "HandsHelping": <FontAwesomeIcon className="header-icon icon-hands-helping hidden lg:inline-block" icon={faHandsHelping} height="1em" width="1em" />
}

const Link = ({href, className, children, langCode, external = false, icon, ...rest}) => {
  return (
    <a
      href={href}
      className={buildClassList(["link", className])}
      target={external ? "_blank" : "_self"}
      lang={langCode}
      xmlLang={langCode}
      rel={external ? "noopener noreferrer" : ""}
      {...rest}
    >
      {icon && iconList[icon]}
      {children}
      {external && <span className="sr-only">This link will open in a new window.</span>}
    </a>
  )
}

export default Link
